import React from "react";
import { Route, Switch } from "react-router-dom";
import "./styles.css";
import LandingPage from "./Pages/LandingPage/LandingPage";
import VideoPage from "./Pages/VideoPage/VideoPage";
// import { workSpace } from "./Constant";

function App() {
  // const Params = useParams();
  return (
    <>
      <Switch>
      <Route path="/videopage/:id">
        <VideoPage />
      </Route>
        <Route path="/" exact >
            <LandingPage />          
        </Route>
      </Switch>
    </>
  );
}

export default App;
